import ObjectFieldValue from "@/components/views/ObjectFieldValue";
import EditFieldValue from "@/components/tables/ObjectFieldsTable/EditFieldValue";

const FieldCell = ({
  val,
  field,
  isEditMode,
  isCurrentEdit,
  unit_uuid,
  object_uuid,
  object_unit_uuid,
  definition_uuid,
  isAdmins,
  color,
  units,
  onChange,
  onKeyDown,
  onComplete,
  canEditObject,
  valueAsObject = false,
}) => {
  return isCurrentEdit ? (
    <EditFieldValue
      value={val}
      field={field}
      units={units}
      unit_uuid={unit_uuid}
      object_uuid={object_uuid}
      object_unit_uuid={object_unit_uuid}
      isAdmins={isAdmins}
      color={color}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onComplete={onComplete}
      definition_uuid={definition_uuid}
      canEditObject={canEditObject}
      valueAsObject={valueAsObject}
    />
  ) : (
    <ObjectFieldValue
      value={val}
      field={field}
      miniature
      unit_uuid={unit_uuid}
      isAdmins={isAdmins}
      color={color}
      notLink={isEditMode}
      canEditObject={canEditObject}
    />
  );
};

export default FieldCell;
